<script setup lang="ts">
  import { track } from '@/helpers/mixpanelDes'

  const props = withDefaults(
    defineProps<{
      title: string
      desc: string
      image: string
      to?: string
      icon?: string
      variant?: 'document' | 'slide' | 'default'
    }>(),
    {
      variant: 'default',
    },
  )

  function handleClick() {
    track('dashboard-link-clicked', { target: props.to })
  }
</script>

<template>
  <RouterLink
    :to="to ? to : '/'"
    class="pr-6 gap-2 bg-white border border-black-90 rounded-lg overflow-hidden justify-start items-center inline-flex transition select-none cursor-pointer w-full hover:shadow-lg"
    @click="handleClick"
  >
    <div v-if="variant === 'document'" class="size-16 relative shrink-0 flex justify-center items-center">
      <img :src="image" class="size-13 top-4 absolute blur-sm opacity-40 object-contain" alt="" />
      <div
        class="w-10 h-12 -bottom-1 bg-[linear-gradient(225deg,transparent_8.5px,white_0)] absolute flex justify-center items-center before:content-[''] before:absolute before:top-0 before:right-0 before:w-0 before:h-0 before:border-b-[12px] before:border-white-gray before:border-r-[12px] before:border-r-transparent before:drop-shadow-[-1px_1px_2px_rgba(0,0,0,0.15)]"
      >
        <img :src="image" class="w-icon" alt="" />
      </div>
    </div>

    <div v-else-if="variant === 'slide'" class="size-16 relative shrink-0 flex justify-center items-center">
      <img :src="image" class="w-12 h-8 blur-sm opacity-40 object-cover absolute" alt="" />
      <div class="w-11 h-8 bg-white absolute flex justify-center items-center rounded-sm border border-black-90">
        <img :src="image" class="w-icon" alt="" />
      </div>
    </div>

    <div v-else class="size-16 shrink-0 flex justify-center items-center">
      <img :src="image" class="h-11" alt="" />
    </div>

    <div class="grow shrink basis-0 flex-col justify-center items-start gap-1 inline-flex flex-1 overflow-hidden">
      <div class="self-stretch justify-start items-center gap-1 inline-flex text-black-10">
        <des-icon :icon="icon" v-if="icon" />
        <div class="text-sm font-semibold leading-4 truncate">{{ title }}</div>
      </div>

      <div class="self-stretch text-black-50 text-xs font-normal leading-4 truncate">{{ desc }}</div>
    </div>
  </RouterLink>
</template>
